import { render } from "./bank-payment.vue?vue&type=template&id=4c096208&scoped=true"
import script from "./bank-payment.vue?vue&type=script&lang=js"
export * from "./bank-payment.vue?vue&type=script&lang=js"

import "./bank-payment.vue?vue&type=style&index=0&id=4c096208&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c096208"]])

export default __exports__